<!--sliding panel-->
<div class="cd-panel js-cd-panel-main"
     [class.cd-panel--from-left]="from === 'left'"
     [class.cd-panel--from-right]="from === 'right'"
     [class.cd-panel--is-visible]="isActive"
     [class.js-cd-close]="!isActive"
     [class.has-backdrop]="isFirstPanel">
  <header class="cd-panel__header">
    <a class="cd-panel__close js-cd-close" (click)="close()">Close</a>
  </header>

  <div class="cd-panel__container" style.margin-right="{{ marginMultiplier * 10 }}px">
    <div class="cd-panel__content">
      <div class="cd_panel__innerWrap">
      <ng-template #canvasContent></ng-template>
      <ng-content></ng-content>
      </div>
      <!-- your side panel content here -->
    </div> <!-- cd-panel__content -->
  </div> <!-- cd-panel__container -->
</div> <!-- cd-panel -->
